import { CALCULATING_TAXES_SUCCESS } from './TaxCalculationConstants';

const initialState = {
  calculatinginvoicesTaxes: false
};

const TaxCalculationReducer = (state = initialState, action) => {
  switch (action.type) {
    case CALCULATING_TAXES_SUCCESS:
      return {
        ...state,
        calculatinginvoicesTaxes: true
      };
    default:
      return state;
  }
};

export default TaxCalculationReducer;


// WEBPACK FOOTER //
// ./src/redux/taxCalculation/TaxCalculationReducer.js